/*
  bfroz-product.js : comportements de la fiche saveur (port de l'état React de FlavorDetail.tsx).
  Chargé par sections/flavor-hero.liquid (defer). Sans dépendance ; l'ajout au panier lui-même
  est délégué à bfroz-cart.js via [data-add-to-cart] + [data-qty-input] dans le [data-product].

  Dans un [data-product] :
    [data-qty-minus] / [data-qty-plus]      qty = max(1, qty - 1) / qty + 1  (setQty de la source)
    [data-qty-display]                      le chiffre visible
    [data-qty-input]                        <input type="hidden" name="quantity">, lu par bfroz-cart.js
    [data-variant-option]                   une rangée par variante ; data-variant-id, data-variant-price
                                            (cents), data-variant-available. Sélection = mêmes styles
                                            inline que la source (fond rgba(255,255,255,0.08), bordure hot-cyan,
                                            point hot-cyan).
    [data-variant-select]                   <select name="id"> masqué, synchronisé
    [data-price]                            prix affiché (format « 39.99$ », BFROZ.cart.money)
    [data-add-to-cart]                      reçoit l'id de la variante sélectionnée
  Dans un [data-accordion-group] :
    [data-accordion-toggle="x"] + [data-accordion-panel="x"] : un seul ouvert à la fois
    (openSection de la source), max-height 0px ↔ 1100px, chevron rotate(0deg) ↔ rotate(180deg),
    transition 300 ms via les classes de la source.
*/
(function () {
  'use strict';

  var BFROZ = (window.BFROZ = window.BFROZ || {});

  function money(cents) {
    if (BFROZ.cart && typeof BFROZ.cart.money === 'function') return BFROZ.cart.money(cents);
    return (Number(cents || 0) / 100).toFixed(2) + '$';
  }

  // ---------- quantité + variantes ----------
  function initProduct(root) {
    if (root.__bfrozProduct) return;
    root.__bfrozProduct = true;

    var input = root.querySelector('[data-qty-input]');
    var display = root.querySelector('[data-qty-display]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    var select = root.querySelector('[data-variant-select]');
    var options = root.querySelectorAll('[data-variant-option]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addLabel = root.querySelector('[data-add-label]');
    var soldOutLabel = root.querySelector('[data-sold-out-label]');
    // le prix « hero » est hors du formulaire : on le cherche dans la section
    var section = root.closest('.shopify-section') || root.closest('section') || document;
    var priceEl = section.querySelector('[data-price]');

    function getQty() {
      var n = parseInt(input ? input.value : '1', 10);
      return isNaN(n) || n < 1 ? 1 : n;
    }
    function setQty(n) {
      n = Math.max(1, n);
      if (input) input.value = String(n);
      if (display) display.textContent = String(n);
    }
    if (minus) {
      minus.addEventListener('click', function () {
        setQty(getQty() - 1);
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        setQty(getQty() + 1);
      });
    }
    setQty(getQty());

    function paintOption(opt, selected) {
      opt.style.backgroundColor = selected ? 'rgba(255,255,255,0.08)' : 'transparent';
      opt.style.border = '1.5px solid ' + (selected ? 'hsl(var(--hot-cyan))' : 'rgba(255,255,255,0.18)');
      opt.setAttribute('aria-pressed', selected ? 'true' : 'false');
      var radio = opt.querySelector('[data-variant-radio]');
      if (radio) radio.style.borderColor = selected ? 'hsl(var(--hot-cyan))' : 'rgba(255,255,255,0.4)';
      var dot = opt.querySelector('[data-variant-dot]');
      if (dot) dot.classList.toggle('hidden', !selected);
    }
    function selectVariant(opt) {
      var id = opt.getAttribute('data-variant-id');
      var available = opt.getAttribute('data-variant-available') !== 'false';
      for (var i = 0; i < options.length; i++) paintOption(options[i], options[i] === opt);
      if (select) select.value = id;
      if (addBtn) {
        addBtn.setAttribute('data-add-to-cart', id);
        addBtn.disabled = !available;
      }
      if (addLabel) addLabel.classList.toggle('hidden', !available);
      if (soldOutLabel) soldOutLabel.classList.toggle('hidden', available);
      if (priceEl) priceEl.textContent = money(opt.getAttribute('data-variant-price'));
    }
    for (var i = 0; i < options.length; i++) {
      (function (opt) {
        opt.addEventListener('click', function () {
          selectVariant(opt);
        });
      })(options[i]);
    }
  }

  // ---------- accordéons ----------
  function initAccordion(group) {
    if (group.__bfrozAccordion) return;
    group.__bfrozAccordion = true;

    var toggles = group.querySelectorAll('[data-accordion-toggle]');
    var open = null;

    function panelFor(key) {
      return group.querySelector('[data-accordion-panel="' + key + '"]');
    }
    function chevronFor(btn) {
      return btn.querySelector('svg');
    }
    function apply() {
      for (var i = 0; i < toggles.length; i++) {
        var btn = toggles[i];
        var key = btn.getAttribute('data-accordion-toggle');
        var isOpen = key === open;
        var panel = panelFor(key);
        var chevron = chevronFor(btn);
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (chevron) chevron.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
        if (panel) {
          panel.style.maxHeight = isOpen ? '1100px' : '0px';
          panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        }
      }
    }
    for (var i = 0; i < toggles.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-accordion-toggle');
          open = open === key ? null : key;
          apply();
        });
      })(toggles[i]);
    }
    apply();
  }

  function init(scope) {
    scope = scope || document;
    var products = scope.querySelectorAll('[data-product]');
    for (var i = 0; i < products.length; i++) initProduct(products[i]);
    var groups = scope.querySelectorAll('[data-accordion-group]');
    for (var j = 0; j < groups.length; j++) initAccordion(groups[j]);
  }

  init();
  // éditeur de thème : une section rechargée revient sans ses écouteurs
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });

  BFROZ.product = { init: init };
})();
